//@ts-strict-ignore
import React from 'react';
import { useSymbolFromCurrency } from '../../utils/CurrencyUtil';

/*
 * Price field & overriding components (Styled to suit particular forms/views).
 * */

export const CategoryGridPrice = (props) => {
  return (
    <div style={{ fontSize: '14px' }}>
      <Price {...props} />
    </div>
  );
};

export const TradeCounterListViewPrice = (props) => {
  return (
    <div
      style={{
        display: 'inline-block',
        verticalAlign: 'top',
        width: props.width || '15%',
        textAlign: 'right',
        fontWeight: 'bold',
      }}
    >
      <Price {...props} />
    </div>
  );
};

type IUsePriceOptions = {
  decimals?: number;
  suffix?: string;
  type?: 'currency' | 'baseCurrency';
};

export const usePrice = (baseValue, { decimals = 2, suffix = '', type = 'currency' }: IUsePriceOptions = {}) => {
  const numericValue = typeof baseValue === 'number' ? baseValue.toFixed(decimals) : baseValue;
  const prefix = useSymbolFromCurrency(type, numericValue);

  return `${prefix}${numericValue}${suffix}`;
};

type IPriceProps = {
  children?: any;
  type?: 'currency' | 'baseCurrency';
  decimals?: number;
  suffix?: string;
};

/**
 * Convenience component for formatted display of a Price value. (Includes currency symbol & decimal places).
 */
const Price = ({ children, type = 'currency', decimals, suffix }: IPriceProps) => {
  const price = usePrice(children === '' || !children || Array.isArray(children) ? 0 : children, {
    decimals,
    suffix,
    type,
  });

  if (Array.isArray(children)) {
    console.warn('Should not have an array as child of Price tag.');
    return <div style={{ fontSize: '14px' }}>{children}</div>;
  }

  return <>{price}</>;
};

Price.defaultProps = {
  currency: { description: 'GBP' },
  decimals: 2,
};

export default Price;
